import React from 'react'
import { useVendors } from 'src/pages/Vendors/vendors.hooks'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'
import { NONE_VALUE } from '../../FilterBar.constants'

export const DashboardVendorFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: vendors } = useVendors()
  const noVendorValue = NONE_VALUE
  const filterValues = [
    noVendorValue,
    ...(vendors?.getVendorsList().map((vendor) => ({
      label: vendor.getName(),
      value: vendor.getName(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_VENDOR}
      filterName={FilterName.DASHBOARD_VENDOR}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
